import * as Enumerable from 'linq';
import { PurchaseOrder } from '../entities/purchase/purchase.order';
import { TaxInclusiveOption } from '../entities/purchase/purchase.order.line';


export class PurchaseOrderUtility {


    public static sumTotalPrice(purchaseOrder: PurchaseOrder): PurchaseOrder {

        let sumBuyPrice = 0;

        Enumerable
            .from(purchaseOrder.lines)
            .forEach(line => {
                sumBuyPrice += line.quantity * line.price;
            });

        purchaseOrder.total = sumBuyPrice;

        return purchaseOrder;

    }

    public static sumTotal(purchaseOrder: PurchaseOrder, taxRate: number): PurchaseOrder {

        const { lines, taxInclusiveOption } = purchaseOrder;

        const isNotMapping = taxRate < 0;

        const rate = taxRate / 100;
        purchaseOrder.total = 0;
        purchaseOrder.tax = 0;
        purchaseOrder.subTotal = 0;
        // purchaseOrder.taxAmount = 0;
        // purchaseOrder.taxIncludedAmount = 0;

        Enumerable
            .from(lines)
            .forEach(line => {

                const lineValue = line.quantity * line.price;
                let lineTax = 0;

                // current now TaxOption is apply all. Therefore typing here for sometime it's move to each line
                switch (taxInclusiveOption) {
                    case TaxInclusiveOption.Exclusive:
                        lineTax = lineValue * rate;
                        break;

                    case TaxInclusiveOption.Inclusive:
                        const divider = 100 + taxRate;
                        const includedTax = (lineValue / divider) * taxRate;
                        lineTax = includedTax;
                        break;
                }

                purchaseOrder.subTotal += lineValue;
                purchaseOrder.tax += lineTax;

            });

        purchaseOrder.total = taxInclusiveOption === TaxInclusiveOption.Exclusive
            ? purchaseOrder.subTotal + purchaseOrder.tax
            : purchaseOrder.subTotal;

        return purchaseOrder;
    }

    public static sumAllTotalPrices(purchaseOrders: PurchaseOrder[]): number {

        let sum = 0;

        Enumerable
            .from(purchaseOrders)
            .forEach(purchaseOrder => {
                const { total, subTotal, tax, taxInclusiveOption } = purchaseOrder;

                let totalEx = 0;

                switch (taxInclusiveOption) {

                    case TaxInclusiveOption.Inclusive:
                        totalEx = total - tax;
                        break;

                    default:
                        totalEx = subTotal;
                        break;
                }

                sum += totalEx;

            });

        return sum;

    }

}
